'use client';

import { usePathname } from 'next/navigation';

import { DeviceSwitcher } from '../../components/device-switcher.component';
import { useHeaderCurrentUserFacade } from '../../hooks/use-header-current-user.facade';
import { useLogoutFacade } from '../../hooks/use-logout.facade';
import { IncompleteProfileDesktopContent } from './desktop/incomplete-profile-desktop-content.component';
import { IncompleteProfileMobileContent } from './mobile/incomplete-profile-mobile-content.component';

export const IncompleteProfileContentContainer = () => {
  const { userName } = useHeaderCurrentUserFacade();
  const { handleLogout } = useLogoutFacade();
  const pathname = usePathname() ?? '';

  return (
    <DeviceSwitcher
      desktop={
        <IncompleteProfileDesktopContent
          userName={userName}
          onLogout={handleLogout}
        />
      }
      mobile={
        <IncompleteProfileMobileContent
          pathname={pathname}
          onLogout={handleLogout}
        />
      }
    />
  );
};
